(function () {
  if (window.spBundleRendererInitialized) {
    return;
  }
  window.spBundleRendererInitialized = true;

  var BUNDLE_SELECTOR = '.sp-bundle-contents';
  var DEFAULT_VARIANT_TITLE = 'Default Title';
  var DEFAULT_TITLE = 'Variant';
  var COLLAPSED_STYLE = 'height: 0px; overflow: hidden;';
  var EXPANDED_STYLE = 'height: auto; overflow: visible;';
  var CLASSES = {
    bundle: 'sp-bundle',
    toggle: 'sp-bundle__toggle',
    toggleContent: 'sp-bundle__toggle-content',
    toggleLabel: 'sp-bundle__toggle-label',
    toggleIcon: 'sp-bundle__toggle-icon',
    collapsed: 'sp-bundle__collapsed',
    table: 'sp-bundle__table',
    row: 'sp-bundle__row',
    imageCell: 'sp-bundle__image-cell',
    imageWrap: 'sp-bundle__image-wrap',
    image: 'sp-bundle__image',
    placeholder: 'sp-bundle__placeholder',
    placeholderIcon: 'sp-bundle__placeholder-icon',
    text: 'sp-bundle__text',
    line: 'sp-bundle__line',
    secondary: 'sp-bundle__secondary',
  };
  var CHEVRON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" aria-hidden="true" class="' +
    CLASSES.toggleIcon +
    '"><path stroke-linecap="round" stroke-linejoin="round" d="m2 9.25 4.646-4.646a.5.5 0 0 1 .708 0L12 9.25"></path></svg>';
  var PLACEHOLDER_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" aria-hidden="true" class="' +
    CLASSES.placeholderIcon +
    '"><g clip-path="url(#image_svg__a)"><path d="M1.5 4A2.5 2.5 0 0 1 4 1.5h6A2.5 2.5 0 0 1 12.5 4v6a2.5 2.5 0 0 1-2.5 2.5H4A2.5 2.5 0 0 1 1.5 10z"></path><circle cx="9.25" cy="4.75" r="0.5"></circle><path stroke-linejoin="round" d="M9.2 4.7h.1v.1h-.1z"></path><path stroke-linecap="round" stroke-linejoin="round" d="m1.5 9 1.448-1.738a1.5 1.5 0 0 1 2.213-.1L6.94 8.938a1.5 1.5 0 0 0 2.122 0l.254-.254a1.5 1.5 0 0 1 2.232.124L12.5 10"></path></g><defs><clipPath id="image_svg__a"><path fill="#fff" d="M0 0h14v14H0z"></path></clipPath></defs></svg>';

  function debounce(fn, wait) {
    var timeoutId;
    return function () {
      var args = arguments;
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function join(parts) {
    return parts.join('');
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseComponents(raw) {
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      if (!Array.isArray(data) || data.length === 0) return null;
      return data;
    } catch (error) {
      return null;
    }
  }

  // Component prices resolve from the kit's bundles.component_prices metafield
  // (the exact map checkout charges from — cart lines keep the parent price
  // because the cart transform only runs at checkout on this plan), falling
  // back to the display-only price the picker wrote into _sp_components.
  function parsePriceMap(raw) {
    if (!raw || raw === 'null') return null;
    try {
      var data = JSON.parse(raw);
      if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
      return data;
    } catch (error) {
      return null;
    }
  }

  function componentUnitPrice(component, priceMap) {
    var fromMap = priceMap ? priceMap[extractNumericId(component.merchandiseId)] : undefined;
    var candidate = fromMap !== undefined ? fromMap : component.price;
    var parsed = parseFloat(candidate);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
  }

  // All-or-nothing, mirroring the checkout function: one unpriced component
  // and the whole bundle keeps the parent-line price display.
  function computeBundleTotal(components, priceMap) {
    var total = 0;
    for (var i = 0; i < components.length; i += 1) {
      var unit = componentUnitPrice(components[i], priceMap);
      if (unit === null) return null;
      total += unit * normalizeQty(components[i].quantity);
    }
    return total;
  }

  function formatMoneyLike(templateText, amount) {
    var formatted = amount.toLocaleString('nb-NO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    // Swap the numeric token inside the existing text so currency placement
    // and suffixes ("kr", "NOK") survive untouched.
    return templateText.replace(/\d[\d\s .]*,\d{2}|\d[\d\s ,]*\.\d{2}|\d[\d\s ]*/, formatted);
  }

  function parseMoneyText(text) {
    if (typeof text !== 'string') return null;
    var match = text.match(/\d[\d\s .]*,\d{2}|\d[\d\s ,]*\.\d{2}|\d[\d\s ]*/);
    if (!match) return null;
    var token = match[0].replace(/[\s ]/g, '');
    if (token.indexOf(',') !== -1) {
      token = token.replace(/\./g, '').replace(',', '.');
    }
    var parsed = parseFloat(token);
    return Number.isFinite(parsed) ? parsed : null;
  }

  // Returns { original, lineTotal } — original is the parent-line total the
  // cart object reported (needed for the running-total correction), lineTotal
  // is the component sum multiplied by the cart line quantity.
  function applyLineTotal(container, bundleTotal) {
    var row = container.closest('.cart-item');
    if (!row) return null;

    var qtyInput = row.querySelector('.quantity__input, input[name="updates[]"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!Number.isFinite(qty) || qty <= 0) qty = 1;
    var lineTotal = bundleTotal * qty;

    var original = null;
    var cells = row.querySelectorAll('.cart-item__totals');
    cells.forEach(function (cell) {
      // Lines with real discount applications render a struck-through pair —
      // leave those alone rather than guessing which number to replace.
      if (cell.querySelector('.cart-item__discounted-prices')) return;
      var priceEl = cell.querySelector('.price--end');
      if (!priceEl) return;
      if (priceEl.dataset.spOriginal === undefined) {
        var parsed = parseMoneyText(priceEl.textContent);
        priceEl.dataset.spOriginal = parsed === null ? '' : String(parsed);
      }
      if (original === null && priceEl.dataset.spOriginal !== '') {
        original = parseFloat(priceEl.dataset.spOriginal);
      }
      priceEl.textContent = formatMoneyLike(priceEl.textContent, lineTotal);
    });

    if (original === null || !Number.isFinite(original)) return null;
    return { original: original, lineTotal: lineTotal };
  }

  function adjustCartTotals() {
    var containers = document.querySelectorAll(BUNDLE_SELECTOR);
    var delta = 0;
    containers.forEach(function (container) {
      var computed = parseFloat(container.dataset.spComputedTotal);
      var original = parseFloat(container.dataset.spOriginalTotal);
      if (Number.isFinite(computed) && Number.isFinite(original)) {
        delta += computed - original;
      }
    });

    document.querySelectorAll('.totals__total-value').forEach(function (el) {
      if (el.dataset.spOriginal === undefined) {
        var parsed = parseMoneyText(el.textContent);
        if (parsed === null) return;
        el.dataset.spOriginal = String(parsed);
      }
      var base = parseFloat(el.dataset.spOriginal);
      if (!Number.isFinite(base)) return;
      el.textContent = formatMoneyLike(el.textContent, base + delta);
    });
  }

  function extractNumericId(merchandiseId) {
    if (typeof merchandiseId !== 'string') return '';
    var match = merchandiseId.match(/(\d+)(?:\D*)$/);
    return match ? match[1] : '';
  }

  function resolveTitles(component) {
    var title = typeof component.title === 'string' ? component.title.trim() : '';
    var variantTitle = typeof component.variantTitle === 'string' ? component.variantTitle.trim() : '';
    var normalizedVariant = variantTitle && variantTitle !== DEFAULT_VARIANT_TITLE ? variantTitle : '';
    var fallbackId = extractNumericId(component.merchandiseId);
    var fallbackTitle = fallbackId ? DEFAULT_TITLE + ' ' + fallbackId : DEFAULT_TITLE;
    var mainTitle = title || normalizedVariant || fallbackTitle;
    var secondaryTitle = title && normalizedVariant && normalizedVariant !== title ? normalizedVariant : '';

    return { mainTitle: mainTitle, secondaryTitle: secondaryTitle };
  }

  function normalizeQty(value) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  }

  function totalQuantity(components) {
    return components.reduce(function (sum, component) {
      return sum + normalizeQty(component.quantity);
    }, 0);
  }

  function normalizeImageUrl(url) {
    if (typeof url !== 'string') return '';
    var trimmed = url.trim();
    if (!trimmed) return '';
    if (
      trimmed.indexOf('http://') === 0 ||
      trimmed.indexOf('https://') === 0 ||
      trimmed.indexOf('//') === 0 ||
      trimmed.indexOf('/') === 0
    ) {
      return trimmed;
    }
    return '';
  }

  function normalizeSizedUrl(url) {
    if (!url) return '';
    return url.replace(/_(\d+x)_\d+x\d+(?=\.[a-zA-Z0-9]+(?:\?|$))/, '_$1');
  }

  function hasSizeSuffix(url) {
    return /_\d+x(\d+)?(?=\.[a-zA-Z0-9]+(?:\?|$))/.test(url);
  }

  function buildSizedImageUrl(url, size) {
    if (!url) return '';
    if (url.indexOf('cdn.shopify.com') === -1) return url;
    var cleaned = normalizeSizedUrl(url);
    if (/[?&]width=/.test(cleaned)) return cleaned;
    if (hasSizeSuffix(cleaned)) return cleaned;
    var width = size;
    if (typeof size === 'string') {
      var match = size.match(/^\d+/);
      width = match ? match[0] : '';
    }
    if (!width) return cleaned;
    return cleaned + (cleaned.indexOf('?') === -1 ? '?width=' : '&width=') + width;
  }

  function buildSrcSet(url) {
    var url1 = buildSizedImageUrl(url, 64);
    var url2 = buildSizedImageUrl(url, 128);
    var url4 = buildSizedImageUrl(url, 256);
    return url1 + ' 1x, ' + url2 + ' 2x, ' + url4 + ' 4x';
  }

  function buildImageMarkup(imageUrl, alt) {
    if (imageUrl) {
      var safeAlt = escapeHtml(alt);
      var srcset = buildSrcSet(imageUrl);
      var src = buildSizedImageUrl(imageUrl, 64);
      return join([
        '<picture>',
        '<source media="(min-width: 0px)" srcset="',
        escapeHtml(srcset),
        '">',
        '<img src="',
        escapeHtml(src),
        '" alt="',
        safeAlt,
        '" loading="eager" class="',
        CLASSES.image,
        '">',
        '</picture>',
      ]);
    }

    return join([
      '<div class="',
      CLASSES.placeholder,
      '">',
      PLACEHOLDER_SVG,
      '</div>',
    ]);
  }

  function buildToggleButton(label) {
    return join([
      '<button type="button" class="',
      CLASSES.toggle,
      '">',
      '<span class="',
      CLASSES.toggleContent,
      '">',
      '<span class="',
      CLASSES.toggleLabel,
      '">',
      label,
      '</span>',
      CHEVRON_SVG,
      '</span>',
      '</button>',
    ]);
  }

  function buildComponentRow(component) {
    var quantity = normalizeQty(component.quantity);
    var titles = resolveTitles(component);
    var imageUrl = normalizeImageUrl(component.imageUrl);
    var mainTitle = escapeHtml(titles.mainTitle);
    var secondaryTitle = titles.secondaryTitle ? escapeHtml(titles.secondaryTitle) : '';
    var lineText = quantity + ' × ' + mainTitle;

    var secondaryMarkup = secondaryTitle
      ? join([
          '<span class="',
          CLASSES.secondary,
          '">',
          secondaryTitle,
          '</span>',
        ])
      : '';

    return join([
      '<div role="row" class="',
      CLASSES.row,
      '">',
      '<div role="cell" class="',
      CLASSES.imageCell,
      '">',
      '<div class="',
      CLASSES.imageWrap,
      '">',
      buildImageMarkup(imageUrl, titles.mainTitle),
      '</div>',
      '</div>',
      '<div role="cell" class="',
      CLASSES.text,
      '">',
      '<span class="',
      CLASSES.line,
      '">',
      lineText,
      '</span>',
      secondaryMarkup,
      '</div>',
      '</div>',
    ]);
  }

  function buildBundleBlock(components) {
    var count = totalQuantity(components);
    var noun = count === 1 ? 'vare' : 'varer';
    var label = 'Skjul ' + count + ' ' + noun;
    var rowsMarkup = components.map(buildComponentRow).join('');

    return join([
      '<div class="',
      CLASSES.bundle,
      '">',
      buildToggleButton(label),
      '<div class="',
      CLASSES.collapsed,
      '" style="',
      EXPANDED_STYLE,
      '">',
      '<div>',
      '<div role="table" aria-label="Bundle items" class="',
      CLASSES.table,
      '">',
      rowsMarkup,
      '</div>',
      '</div>',
      '</div>',
      '</div>',
    ]);
  }

  function cleanup(container) {
    container.innerHTML = '';
    container.classList.remove('sp-bundle-contents--ready');
    container.classList.remove('sp-bundle-contents--collapsed');
    container.dataset.spRendered = '';
    container.dataset.spToggleBound = '';
    container.dataset.spComponentCount = '';
  }

  function attachToggle(container) {
    if (container.dataset.spToggleBound === 'true') return;
    var button = container.querySelector('button.' + CLASSES.toggle);
    var collapsed = container.querySelector('.' + CLASSES.collapsed);
    if (!button || !collapsed) return;

    button.addEventListener('click', function () {
      var isCollapsed = container.classList.contains('sp-bundle-contents--collapsed');
      var count = parseInt(container.dataset.spComponentCount || '0', 10);
      var noun = count === 1 ? 'vare' : 'varer';
      var label = (isCollapsed ? 'Skjul ' : 'Vis ') + count + ' ' + noun;
      var labelSpan = button.querySelector('.' + CLASSES.toggleLabel);

      if (isCollapsed) {
        container.classList.remove('sp-bundle-contents--collapsed');
        collapsed.setAttribute('style', EXPANDED_STYLE);
      } else {
        container.classList.add('sp-bundle-contents--collapsed');
        collapsed.setAttribute('style', COLLAPSED_STYLE);
      }

      if (labelSpan) {
        labelSpan.textContent = label;
      }
    });

    container.dataset.spToggleBound = 'true';
  }

  function renderContainer(container) {
    if (!container) return;

    var raw = container.dataset.spComponents;
    var schema = container.dataset.spSchema;

    if (schema && schema !== '1') {
      cleanup(container);
      return;
    }

    if (!raw) {
      cleanup(container);
      return;
    }

    if (container.dataset.spRendered === raw) return;

    var components = parseComponents(raw);
    if (!components) {
      cleanup(container);
      return;
    }

    var priceMap = parsePriceMap(container.dataset.spPrices);
    container.dataset.spComponentCount = String(totalQuantity(components));
    container.innerHTML = buildBundleBlock(components);
    container.classList.add('sp-bundle-contents--ready');
    container.classList.remove('sp-bundle-contents--collapsed');
    container.dataset.spRendered = raw;
    container.dataset.spToggleBound = '';
    attachToggle(container);

    var total = computeBundleTotal(components, priceMap);
    var applied = total !== null ? applyLineTotal(container, total) : null;
    if (applied) {
      container.dataset.spComputedTotal = String(applied.lineTotal);
      container.dataset.spOriginalTotal = String(applied.original);
    } else {
      container.dataset.spComputedTotal = '';
      container.dataset.spOriginalTotal = '';
    }
  }

  function renderAll(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll(BUNDLE_SELECTOR);
    containers.forEach(renderContainer);
    adjustCartTotals();
  }

  function initObservers() {
    if (!('MutationObserver' in window)) return;

    var targets = [];
    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) targets.push(cartDrawer);

    var mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) targets.push(mainCartItems);

    if (!targets.length) return;

    var scheduleRender = debounce(function () {
      renderAll();
    }, 120);

    targets.forEach(function (target) {
      var observer = new MutationObserver(function () {
        scheduleRender();
      });
      observer.observe(target, { childList: true, subtree: true });
    });
  }

  function init() {
    renderAll();
    initObservers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
